/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./airdrop.vue?vue&type=template&id=1dac32c8&scoped=true"
import script from "./airdrop.vue?vue&type=script&lang=js"
export * from "./airdrop.vue?vue&type=script&lang=js"
import style1 from "./airdrop.vue?vue&type=style&index=1&id=1dac32c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dac32c8",
  null
  
)

export default component.exports